module.exports = __webpack_public_path__ + "static/media/cover.9d89b4d8.png";